import { clsx } from 'clsx';

import { useBreakpoints } from 'Shared/ResponsiveBreakpoints';

type PropsT = {
  isDisabled?: boolean;
  subTitle: string;
  title: string;
  availableCountText?: string;
};

export const LinkTitle: React.FunctionComponent<PropsT> = ({
  isDisabled,
  subTitle,
  title,
  availableCountText,
}) => {
  const { isMdScreen } = useBreakpoints();

  return (
    <div className="mx-24 text-left md:mr-48">
      <div className="flex justify-between">
        <div
          className={clsx(
            'mb-6 text-large-b',
            isDisabled ? 'text-share-text-2' : 'text-share-text',
          )}
        >
          {title}
        </div>

        {availableCountText && isMdScreen ? (
          <div className="text-medium-r text-share-text-2">
            {availableCountText}
          </div>
        ) : null}
      </div>

      <div className="text-medium-r text-share-text-3">{subTitle}</div>
      {availableCountText && !isMdScreen ? (
        <div className="text-medium-r text-share-text-2">
          {availableCountText}
        </div>
      ) : null}
    </div>
  );
};
